(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-faq-v2"] && !Shopify.designMode) return;
  try {
    
  class FaqItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('[data-accordion-button]');
      this.content = this.querySelector('[data-accordion-content]');
      this.button.addEventListener('click', () => {
        this.handleButtonClick();
      });
    }

    handleButtonClick() {
      const isActive = this.classList.contains('active');

      if (isActive) {
        this.closeAccordion(this, this.button, this.content);
      } else {
        this.openAccordion(this, this.button, this.content);
      }
    }

    openAccordion(item, button, content) {
      item.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    closeAccordion(item, button, content) {
      item.classList.remove('active');
      button.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0';
    }
  }

  customElements.define('faq-item', FaqItem);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('.new-faq_item');

    faqItems.forEach(item => {
      const question = item.querySelector('.new-faq_question');
      const answer = item.querySelector('.new-faq_answer');
      const toggleIcon = item.querySelector('.new-faq_toggle-icon svg');

      question.addEventListener('click', function() {
        const isExpanded = answer.style.display === 'block';

        answer.style.display = isExpanded ? 'none' : 'block';
        toggleIcon.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(180deg)';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
  
    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        var subContainer = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations__inner").innerHTML;
      }
    };
    request.send();
  };
  // If your section has theme settings, the theme editor
  // reloads the section as you edit those settings. When that happens, the
  // recommendations need to be fetched again.
  // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
